module.exports = __webpack_public_path__ + "img/xiaochengxu.2bc45626.jpg";